<template>
  <a
    :href="href"
    id="scroll-top"
    class="smooth-scroll pa-0 px-lg-3 py-lg-2"
    :class="{ show: displayButton }"
    aria-label="Back to top"
    @click.prevent="handleClick"
  >
    <SvgWrapper use="icon_svg_up" dimensions="15" />
    <span
      class="d-none d-lg-block mt-1 c-white"
      v-html="translate('pdp_back_to_top_button')"
    ></span>
  </a>
</template>

<script>
import { HTML_EVENT } from '@/constants/GlobalConstants'
import { defineAsyncComponent } from 'vue'

const SvgWrapper = defineAsyncComponent(
  () => import('@/components/basic/atoms/SvgWrapper.vue')
)
const MINIMUM_DISTANCE_FROM_TOP = 800

export default {
  components: { SvgWrapper },
  props: {
    href: String
  },
  data() {
    return {
      displayButton: false,
      lastScrollPosition: 0
    }
  },
  methods: {
    handleScroll() {
      const topPos = window.top.scrollY
      this.displayButton =
        this.lastScrollPosition > topPos && topPos > MINIMUM_DISTANCE_FROM_TOP
      this.lastScrollPosition = topPos
    },
    async handleClick() {
      const { default: DomHelper } = await import(
        '@/services/helpers/DomHelper'
      )
      DomHelper.scrollTo(this.href)
    }
  },
  mounted() {
    document.addEventListener(HTML_EVENT.SCROLL, this.handleScroll)
  }
}
</script>
<style scoped>
#scroll-top,
#scroll-top:active,
#scroll-top:focus {
  display: inline-flex;
  position: relative;
  border-radius: 50%;
  transform: translateX(-200%);
  left: 30px;
  right: auto;
  bottom: 0;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 50px;
  height: 50px;
  background: rgb(var(--v-theme-gray));
  color: rgb(var(--v-theme-white));
  font-size: var(--m-font-size);
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  transition: var(--transition-duration-xl);

  &:before {
    content: none;
  }

  &:hover {
    color: rgb(var(--v-theme-white));
    background: rgb(var(--v-theme-clay));
  }

  &.show {
    transform: translateX(0);
  }

  svg {
    stroke-width: 4px;
    stroke: rgb(var(--v-theme-white));
  }
}

.display-lg-and-up #scroll-top,
.display-lg-and-up #scroll-top:active,
.display-lg-and-up #scroll-top:focus {
  display: flex;
  position: fixed;
  bottom: 120px;
  height: auto;
  width: 75px;
  border-radius: 4px;
  left: 30px;
  right: auto;

  &.show {
    transform: translateX(0);
  }
}

@media (max-width: 960px) {
  #scroll-top {
    bottom: 120px !important;
  }
}
</style>
